<template>
    <div>
        <product-addons />
        <hr>
        <product-questions />
        <hr>
        <product-requirements />
    </div>
</template>
<script>
import ProductAddons from "./ProductAddons.vue"
import ProductQuestions from "./ProductQuestions.vue"
import ProductRequirements from "./ProductRequirements.vue"

export default {
    components:{
        ProductAddons,
        ProductQuestions,
        ProductRequirements
    }
}
</script>
